const frontendURL = "https://emsupplychain.app/";
// const frontendURL = "http://localhost:3030/";

export default frontendURL;
